import React, { useState } from 'react';
import API from '../../api/axiosInstance';

const EditAccreditationCategoryForm = ({ onClose, onUpdated, categoryToEdit }) => {
  const [name, setName] = useState(categoryToEdit.category_name || '');
  const [categoryFunction, setCategoryFunction] = useState(categoryToEdit.function || '');
  const [code, setCode] = useState(categoryToEdit.code || '');
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await API.put(`/ems/accreditation-categories/${categoryToEdit._id}`, {
        category_name: name,
        function: categoryFunction,
        code,
      });
      onUpdated();
      onClose();
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Failed to update accreditation category';
      alert(msg);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.4)' }}>
      <div className="modal-dialog modal-md" role="document">
        <div className="modal-content">
          <form onSubmit={handleSubmit}>
            <div className="modal-header">
              <h5 className="modal-title">Edit Accreditation Category</h5>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
            </div>

            <div className="modal-body">
              <div className="mb-3">
                <label className="form-label">Category</label>
                <input
                  type="text"
                  className="form-control"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Function</label>
                <input
                  type="text"
                  className="form-control"
                  value={categoryFunction}
                  onChange={(e) => setCategoryFunction(e.target.value)}
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Code</label>
                <input
                  type="text"
                  className="form-control"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="modal-footer">
              <button type="submit" className="btn btn-warning" disabled={saving}>
                {saving ? 'Saving…' : 'Save Changes'}
              </button>
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditAccreditationCategoryForm;
